import Store from '@/store.js';

/**
 * Role Management
 */
export const ADMIN = 'isAdmin';
export const STUDENT = 'isStudent';
export const EMPLOYEE = 'isEmployee';
export const EMPLOYEE_DIRECTOR = 'employee.isDirector';
export const EMPLOYEE_MANAGER = 'employee.isManager';
export const EMPLOYEE_BRANCH_STAFF = 'employee.isBranchStaff';
export const EMPLOYEE_TEACHER = 'employee.isTeacher';
export const EMPLOYEE_COORDINATOR = 'employee.isCoordinator';
export const EMPLOYEE_MENTOR = 'employee.isMentor';
export const EMPLOYEE_BRANCH_HEAD = 'employee.isBranchHead';

export default {
    guest(to, from, next) {
        next(Store.getters.isAuthenticated ? {name: 'index', replace: true} : true);
    },
    authentication(to, from, next) {
        if (!Store.getters.isAuthenticated) {
            next({name: 'authenticate/login', replace: true});
        } else if (typeof to.meta !== typeof undefined) {
            /**
             * Role access control
             */
            var roles = to.meta.roles || [];
            var profile = Store.getters.profile;
            if (roles.length && Object.keys(profile).length) {
                var elligible = false;
                for (var i = 0; i < roles.length; i++) {
                    var role = roles[i];
                    if (role.indexOf('.') > -1) {
                        var attributes = role.split('.');
                        var attribute = profile;
                        for (var j = 0; j < attributes.length; j++) {
                            if (attribute) {
                                attribute = attribute[attributes[j]];
                            } else {
                                break;
                            }
                        }
                        if (typeof attribute === 'boolean' && attribute) {
                            elligible = true;
                            break;
                        }
                    } else {
                        if (typeof profile[role] !== typeof undefined && profile[role]) {
                            elligible = true;
                            break;
                        }
                    }
                }
                if (!elligible) {
                    next({name: 'error', replace: true, params: {code: 403, message: "Not Authorize"}});
                }
            }
        }
        next();
    }
}

export function has(role) {
    var profile = Store.getters.profile;
    return typeof profile[role] !== typeof undefined && profile[role];
}


// WEBPACK FOOTER //
// ./src/services/middleware.js